import { createContext, useContext } from 'react';

export type TrackerDownloadSource =
  | { kind: 'document-summary'; documentId: string }
  | { kind: 'presentation'; presentationId: string };

interface WorkflowTrackerDownloadsContextValue {
  awaitTrackerDownload: (
    trackerId: string,
    source: TrackerDownloadSource
  ) => void;
  pendingPresentationIds: string[];
}

export const WorkflowTrackerDownloadsContext = createContext<
  WorkflowTrackerDownloadsContextValue | undefined
>(undefined);

function useWorkflowTrackerDownloadsContext() {
  const context = useContext(WorkflowTrackerDownloadsContext);
  if (!context) {
    throw new Error(
      'Workflow tracker downloads require the current user tracker provider'
    );
  }
  return context;
}

export function useAwaitTrackerDownload() {
  return useWorkflowTrackerDownloadsContext().awaitTrackerDownload;
}

export function useIsPresentationExportPending(presentationId: string) {
  return useWorkflowTrackerDownloadsContext().pendingPresentationIds.includes(
    presentationId
  );
}
